import Store from "@/store";
import { RoleName, navMenu, expandRole } from "@/types";

const readable = "read";
const editable = "edit";
export const convertList = [
  { roleKey: "employee", naviKey: "employees", checkType: readable, trialAccess: true },
  { roleKey: "applicant", naviKey: "applicants", checkType: readable, trialAccess: false },
  { roleKey: "analysis", naviKey: "analysis", checkType: readable, trialAccess: true },
  { roleKey: "asBroadcast", naviKey: "as", checkType: editable, trialAccess: true },
  { roleKey: "manage", naviKey: "organization", checkType: editable, trialAccess: true },
  { roleKey: "specialManage", naviKey: "advance", checkType: editable, trialAccess: true },
  { roleKey: "employeeStats", naviKey: "", checkType: readable, trialAccess: true },
  { roleKey: "applicantStats", naviKey: "", checkType: readable, trialAccess: true }
] as const;

async function getAccessibleDepartment() {
  return "all";
  // TODO refer auth.role
  // return Store.getInstance().getAuth()?.departmentId
}
/**
 * 指定されたロールよりも強い権限かを判定する
 * @param role 比較対象のロール
 * @return 判定結果
 */
export function isStrongerThan(role: RoleName) {
  return Number(role) >= Number(Store.getInstance().getRole()?.id);
}
/**
 * グロナビメニュー選定
 * roleのpermissionsと比較して表示権限のあるグロナビを返却する
 * roleかpermissonsが存在しない場合はダッシュボードのみを返却する
 * roleId=1の場合判定せずnavを返却する
 * @param nav 全てのナビメニュー
 * @returns disNav 権限と比較した結果のナビメニュー
 */
export function setNavByRole(nav: navMenu[], isTrial: boolean) {
  const role = Store.getInstance().getRole();
  const permissions: expandRole = Store.getInstance().getRole().permissions as expandRole;
  if (!role || !permissions) return [nav[0]];
  // for SystemAdmin
  if (role && role.id && parseInt(role.id) === parseInt(RoleName.SystemAdmin)) return nav;
  const disNav = nav.reduce(
    (p: navMenu[], c: navMenu): navMenu[] => {
      const t = convertList.find(l => l.naviKey === c.id);
      if (c.id === "dashboard") return p;

      // if trial plan, can not access some menu
      if (t && !t.trialAccess && isTrial) return p;

      if (t && permissions[t.roleKey] && permissions[t.roleKey]!.includes(t.checkType)) {
        p.push(c);
      }
      return p;
    },
    [nav[0]]
  );
  return disNav;
}
/**
 * 読み取り権限判定
 * @param target role.permissionsキー
 * @returns boolean
 */
export function isReadable(target: string): boolean {
  const role: expandRole = Store.getInstance().getRole().permissions! as expandRole;
  if (!role) return false;
  return role.hasOwnProperty(target) ? role[target].includes(readable) : false;
}
/**
 * 書き込み権限判定
 * @param target role.permissionsキー
 * @returns boolean
 */
export function isEditable(target: string): boolean {
  const role: expandRole = Store.getInstance().getRole().permissions! as expandRole;
  if (!role) return false;
  return role.hasOwnProperty(target) ? role[target].includes(editable) : false;
}
